'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415 from "./presto.-Freemium2-F-A-Add-View$$anon$15.js";
import * as $j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024 from "./presto.types$-Freemium-Seed-Result$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$14() {
  this.aUb = null;
  this.aU3 = null;
  this.aU4 = false;
  this.aUc = null;
  this.aUd = false;
  this.aUg = null;
  this.aU9 = null;
  this.aUa = false;
  this.aU5 = null;
  this.aU6 = false;
  this.aU7 = null;
  this.aU8 = false;
  this.aUe = false;
  this.aUf = false;
  this.aUb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aUg = "FreemiumSeedResult";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$14 as $c_Lpresto_Freemium2FAAddView$$anon$14 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$14;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$14() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$14 as $h_Lpresto_Freemium2FAAddView$$anon$14 };
$h_Lpresto_Freemium2FAAddView$$anon$14.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aUb;
});
$p.M = (function() {
  if ((!this.aU4)) {
    this.aU3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aU4 = true;
  }
  return this.aU3;
});
$p.O = (function() {
  if ((!this.aUd)) {
    this.aUc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aUd = true;
  }
  return this.aUc;
});
$p.D = (function() {
  return this.aUg;
});
$p.t = (function() {
  if ((!this.aUa)) {
    this.aU9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("error", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aUa = true;
  }
  return this.aU9;
});
$p.N = (function() {
  if ((!this.aU6)) {
    this.aU5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aU6 = true;
  }
  return this.aU5;
});
$p.Q = (function() {
  if ((!this.aU8)) {
    this.aU7 = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002415.$c_Lpresto_Freemium2FAAddView$$anon$15();
    this.aU8 = true;
  }
  return this.aU7;
});
$p.v = (function() {
  if ((!this.aUf)) {
    this.aUe = false;
    this.aUf = true;
  }
  return this.aUe;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee133) => ((p) => \u03b4scrutinee133.cHv(p)))($j_presto$002etypes$0024$002dFreemium$002dSeed$002dResult$0024.$m_Lpresto_types$FreemiumSeedResult$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$14, "presto.Freemium2FAAddView$$anon$14", ({
  IR: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$14 as $d_Lpresto_Freemium2FAAddView$$anon$14 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$14.js.map
